import { ButtonProps } from "@interfaces/uiElementTypes";
import { ClipLoader } from "@node_modules/react-spinners";

const Button: React.FC<ButtonProps> = ({
  type = "button",
  className = "",
  children,
  disabled = false,
  loading = false,
  onClick,
  style,
}) => {
  return (
    <button
      type={type}
      className={className}
      disabled={disabled}
      onClick={onClick}
      style={style}
    >
      {loading ? <ClipLoader size={20} color="#ffffff" /> : children}
    </button>
  );
};

export default Button;
